// extracted by css-extract-rspack-plugin
export default {"photo":"_79aab8c3","fadeIn":"_b682bc8e","forceOpacity":"_8bb2c6b"};